var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('el-dialog',{staticClass:"common-popup",class:[
    _vm.device.isMobile ? 'common-popup-mobile' : '',
    _vm.device.isIPhoneX ? 'common-popup-x' : ''
  ],staticStyle:{"z-index":"10000"},attrs:{"title":_vm.dialogTitle,"visible":_vm.visible,"destroy-on-close":true,"append-to-body":true},on:{"update:visible":function($event){_vm.visible=$event},"close":_vm.closeHandle}},[_c('commonIndex',{attrs:{"bookContent":_vm.content}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }